export default "__VITE_ASSET__CSONn1Kv__"